import NetworkingList from './NetworkingList';

const Networking: React.FC = () => {
  return <NetworkingList />;
};

export default Networking;
